<template>
    <div class="wrapper">

        <Loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="false"></Loading>


        <!-- Page Tittle Start -->
        <section class="page-tittle page-tittle-lg bg dark-overlay bgBanner">
            <div class="container">
                <div class="page-tittle-head display-block text-center">
                    <h2>Orodja</h2>
                </div>
            </div>
        </section>
        <!-- Page Tittle End -->

        <!-- Categories Start -->
        <section class="section-1 pt-5">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="shop-sidebar sidebar-left">
                                    <div class="widget widget-search">
                                        <h3 class="widget-tittle">Iskanje</h3>
                                        <label class="input-wrapper">
                                            <input
                                                    type="search"
                                                    class="form-control"
                                                    placeholder="vnesi iskalni pojem"
                                                    v-model="query"
                                                    @input="filterData($event.currentTarget.value)"
                                            />
                                            <a href="" class="btn inline-submit mrg-top-5"><i class="ei ei-search"></i></a>
                                        </label>
                                    </div>
                                    <div class="widget widget-link">
                                        <h3 class="widget-tittle">Kategorije</h3>
                                        <ul class="link">
                                            <li v-for="item in categories" :key="'category_'+ item.id"><a href="#"
                                                                                                          @click="filterToCategory(item.id)">{{item.name}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <button class="btn btn-md btn-dark"
                                            @click="() => { toolsToDisplay = tools; query='';}">Počisti filtre
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-9">

                                <p class="mrg-btm-20 text-dark font-size-20"><b>Orodja</b></p>
                                <div class="row" v-if="toolsToDisplay.length > 0">

                                    <div class="col-md-4" v-for="(item, index) in toolsToDisplay"
                                         :key="'item_'+item.id">
                                        <div class="shop-product pb-1 overflow-hidden">
                                            <div @click="$router.push({name: 'Tool', params: { id: item.id }})"
                                                 style="cursor: pointer;">
                                                <a href="" class="product-name">{{item.name}}</a>
                                                <p>{{getReadableCategory(item.category)}}</p>
                                                <img class="product-img img-responsive" :src="item.photo"
                                                     style="max-height: 160px; max-width: 360px;"
                                                     alt="">
                                                <small class="mt-2 text-muted d-block">@{{getReadableUser(item.location)}}</small>
                                            </div>
                                            <div class="add-to-cart">
                                                <a class="btn btn-primary text-white rounded-circle" style="width: 38px"
                                                   @click="$router.push({name: 'Tool', params: { id: item.id }})"><i
                                                        class="far fa-file-alt"></i></a>
                                                <a class="btn btn-success text-white rounded-circle" style="width: 38px"
                                                   @click="onWhatsappClick(item)"><i class="fab fa-whatsapp"></i></a>
                                            </div>

                                            <div v-if="isAdmin || (getUserDetails.id === item.createdBy)"
                                                 class="alert alert-info p-1 mt-2">
                                                <div class="my-1">
                                                    <router-link :to="{ name: 'EditTool', params: {id: item.id }}"
                                                                 class="btn btn-primary btn-sm text-white mb-0">
                                                        <i class="fa fa-edit"></i> Uredi
                                                    </router-link>

                                                    <a class="btn btn-danger btn-sm text-white ml-1 mb-0"
                                                       @click="deleteToolConfirmation(item)"><i
                                                            class="fa fa-trash"></i> Odstrani</a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="toolsToDisplay.length === 0">
                                    <div class="col-md-12">
                                        <div class="alert alert-info">
                                            <em><i class="fa fa-exclamation-triangle mr-3"></i> Ni zadetkov za
                                                prikaz!</em>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Categories End -->
    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../main'
    import {VueGoodTable} from 'vue-good-table'
    import 'vue-good-table/dist/vue-good-table.css'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'

    export default {
        name: 'Tools',
        components: {
            VueGoodTable,
            Loading
        },
        data() {
            return {
                isLoading: false,
                tools: this.$store.getters.getTools,
                toolsToDisplay: this.$store.getters.getTools,
                categoryId: this.$route.params.categoryId,
                isAdmin: JSON.parse(sessionStorage.getItem("HRAM_user")).administrator,
                users: [],
                categories: [],
                contactPersons: [],
                query: '',
                columns: [
                    {
                        label: 'Slika',
                        field: 'photo',
                        type: 'text',
                        sortable: false,
                        width: '70px'
                    },
                    {
                        label: 'Naziv',
                        field: 'name',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Opis',
                        field: 'description',
                        type: 'text',
                        sortable: false,
                        width: '300px'
                    },
                    {
                        label: 'Kategorija',
                        field: 'category',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Lokacija',
                        field: 'location',
                        type: 'text',
                        sortable: true,
                    },
                    {
                        label: 'Akcije',
                        field: 'id',
                        type: 'text',
                        sortable: false,
                        width: '200px'
                    }
                ],
            }
        },
        firestore() {
            return {
                users: db.collection('users'),
                categories: db.collection('categories'),
            }
        },
        mounted() {
            const _this = this

            _this.isLoading = true;
            let p1 = _this.$store.dispatch('retrieveTools');

            Promise.all([p1]).then((values) => {
                _this.isLoading = false

                _this.tools = _this.$store.getters.getTools;
                _this.toolsToDisplay = _this.$store.getters.getTools;

                if (_this.categoryId) {
                    console.log("categoryId", _this.categoryId);
                    _this.filterToCategory(_this.categoryId);
                }
            })
        },
        computed: {
            getUserDetails() {
                return this.$store.getters.getUserDetails;
            },
            getPeople() {
                let people = [];

                _.map(this.users, function (item) {
                    _.each(item.people, function (innerItem) {
                        people.push(innerItem);
                    });
                });

                people = _.sortBy(people, function (item) {
                    return item.name;
                });

                return people;
            }
        },
        methods: {
            deleteToolConfirmation(data) {
                const _this = this

                this.$swal({
                    title: 'Opozorilo',
                    text: 'Ali ste prepričani, da želite izbrisati orodje ' + data.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
                    dangerMode: true,
                    buttons: {
                        cancel: {
                            text: 'Prekliči',
                            value: null,
                            visible: true,
                            className: '',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Izbriši',
                            value: true,
                            visible: true,
                            className: '',
                            closeModal: true
                        }
                    },
                })
                    .then((value) => {

                        switch (value) {

                            case true:

                                _this.deleteTool(data.id)

                            case null:

                                return

                                break

                            default:

                        }
                    })
            },
            deleteTool(id) {
                const _this = this
                _this.isLoading = true
                db.collection('tools').doc(id).delete()
                    .then(function () {
                        _this.isLoading = false
                        _this.$router.push('/orodja')
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error('Error deleting tool: ', error)
                    })
            },

            getReadableUser(userId) {
                const _this = this

                console.log("userId", userId);

                if (_this.users.length > 0 && userId &&  userId !== -1) {
                    let userObj = _.filter(_this.users, {'id': userId})[0] || _.filter(_this.users, {'id': userId.toLowerCase()})[0];
                    console.log(userObj);
                    console.log(_.filter(_this.users, {'id': userId})[0]);
                    console.log(_.filter(_this.users, {'id': userId.toLowerCase()})[0]);
                    if (userObj) {
                        return userObj.displayName
                    } else {
                        return userId
                    }
                } else {
                    return 'na drugi lokaciji'
                }
            },

            getReadableCategory(categoryId) {
                const _this = this

                if (_this.categories.length > 0) {
                    let categoryObj = _.filter(_this.categories, {'id': categoryId})[0]
                    return categoryObj.name
                }

            },

            onWhatsappClick(item) {
                const _this = this;


                let contactPerson = _.filter(_this.getPeople, {'name': item.contactPerson})[0];

                console.log(contactPerson);
                console.log(contactPerson.phone.substr(1, contactPerson.phone.length));

                let whatsappLink = "https://api.whatsapp.com/send?phone=" + "00386" + contactPerson.phone.substr(1, contactPerson.phone.length) + "&text=" + encodeURIComponent("Živjo " + contactPerson.name.split(" ")[0] + ", španovija vprašanje :) Zanima me: " + item.name);
                window.open(whatsappLink);
            },

            filterData(query) {
                const _this = this;
                _this.toolsToDisplay = _.filter(_this.tools, function (_item) {
                    return JSON.stringify(_item).toLowerCase().includes(query.toLowerCase());
                });
            },

            filterToCategory(categoryId) {
                const _this = this;

                _this.toolsToDisplay = _.filter(_this.tools, function (_item) {
                    return _item.category === categoryId;
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Tools.vue